import { z } from "zod/v4";

export const sportSchema = z.enum(["beach", "padel", "tennis"]);
export const courtSurfaceSchema = z.enum(["sand", "hard", "grass", "artificial"]);
export const courtStatusSchema = z.enum(["active", "maintenance", "closed"]);

export const courtSchema = z.object({
	id: z.string().uuid(),
	location_id: z.string().uuid(),
	name: z.string(),
	sport: sportSchema,
	surface: courtSurfaceSchema,
	status: courtStatusSchema,
	created_at: z.coerce.date(),
	updated_at: z.coerce.date(),
});

export const createCourtSchema = z.object({
	name: z.string().min(1),
	sport: sportSchema,
	surface: courtSurfaceSchema,
});

export const updateCourtSchema = z.object({
	name: z.string().min(1).optional(),
	sport: sportSchema.optional(),
	surface: courtSurfaceSchema.optional(),
	status: courtStatusSchema.optional(),
});
